import React, { useMemo } from "react";
import { useSpring, animated } from "@react-spring/web";
import css from "./DoneStage.module.scss";
import { SlideBox } from "../SlideBox";
import { useClassNames } from "@greeter-venue/utility/Hooks";

export type DoneStageProps = {
  text?: string;
  className?: string;
};

export const DoneStage: React.FC<DoneStageProps> = ({
  text = "Ordre accepteret!",
  className,
}) => {
  const classNames = useClassNames(css.btnAccepted, className);

  const props = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    config: { duration: 1200 },
  });
  return (
    <SlideBox>
      <animated.button style={props} className={classNames}>
        {text}
      </animated.button>
    </SlideBox>
  );
};
